import React, { useEffect } from "react"
import Header from "../components/Header"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const PromoSoon: React.FC = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<div className="relative ">
				<picture>
					<source media="(min-width: 768px)" srcSet={"/images/promoSoonOverHeader.jpg"} />
					<img src={"/images/promoSoonOverHeader.jpg"} className=" block w-full" alt="Danke" />
				</picture>

				<h2 className="xl:text-[70px] text-[25px] sm:text-[45px]  absolute left-0 bottom-[40%] translate-y-1/2 w-full  text-center  ">
					VIELEN DANK FÜR DEIN INTERESSE
					<span className="text-[#78BE20] block">AN UNSEREM GEWINNSPIEL.</span>
				</h2>
			</div>
			<div className="text-center pt-12 px-4">
				<p className="font-CalibriRegular text-[14px] sm:text-[24px] mt-4 max-w-[905px] mx-auto">
					Leider ist eine Teilnahme erst ab dem 26.05.2026 möglich. Besuche uns so lange auf{" "}
					<a href="https://de.bulldogskincare.com/" target="_blank" className="underline">
						de.bulldogskincare.com
					</a>{" "}
					und bleib auf dem Laufenden.
				</p>

				<div className="pb-12 pt-8 text-center">
					<img src={"/images/bulldog.png"} alt="Bulldog Produkte" className="mx-auto block max-w-[220px]  " />

					<a href="https://de.bulldogskincare.com/" target="_blank" className="btn btn-green">
						Zur Bulldog-Website
					</a>
				</div>
			</div>
		</>
	)
}
export default PromoSoon
